import { useCallback, useEffect, useState } from "react";
import {
  Grid,
  InputAdornment,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Typography,
  Snackbar,
  Alert,
  DialogActions,
  Button,
  Box,
} from "@mui/material";
import DashboardFrontCard from "../../TlComponent/DashboardFrontCard/DashboardFrontCard";
import AppHeader from "../../../../common/Pages/AppHeader/AppHeader";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { AuthenticationApi } from "../../../../API/Authentication/LoginApi";
import "./style.css";

const Dashboard = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState<any>();
  const [searchValInput, setSearchValInput] = useState("");
  const [tlListData, setTlListData] = useState<any[]>([]);
  const [tlCountData, setTlCountData] = useState<any>();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [listData, setListData] = useState<any>({});
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [selectedTlId, setSelectedTlId] = useState(null);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "error"
  );

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#3b3b3b",
    font: "Rubik",
  };

  const fetchTlListData = useCallback(() => {
    if (searchValInput && searchValInput.length < 3) {
      // If less than 3 digits entered, show "No data available"
      //setTlListData([]);
      setTotalCount(0);
      return;
    }
  
    AuthenticationApi.api
      ?.TlList(searchValInput, page, rowsPerPage)
      .then((response) => {
        if (response.code === 2001) {
          setSnackbarOpen(true);
          setTlListData([]);
          setTotalCount(0);
          setSnackbarMessage("Invalid User!!!");
        } else if (response.data?.tlDetails?.length > 0) {
          setTlListData(response.data.tlDetails);
          setTotalCount(response.data.listCount);
        } else {
          setTlListData([]);
          setTotalCount(0); // Set 0 instead of 1
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  }, [searchValInput, page, rowsPerPage]);
  
useEffect(() => {
    setPage(0);
  }, [searchValInput]);
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchTlListData();
    }, 500); // Wait 500ms after the user stops typing

    return () => clearTimeout(debounceTimer);
  }, [fetchTlListData]);

  const fetchTlData = () => {
    AuthenticationApi.api
      ?.TlData()
      .then((response) => {
        if (response.code === 2000) {
          setTlCountData(response.data);
        } else {
          setTlCountData([]);
        }
      })
      .catch((error) => {
        console.error("API call error: ", error);
      });
  };
  useEffect(() => {
    fetchTlData();
  }, []);

  const handleDisableClick = (tlId: any) => {
    AuthenticationApi.api
      ?.DisableTl(tlId)
      .then((response) => {
        if (response?.code === 2000) {
          setSnackbarMessage("Disabled TL successfully!");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          fetchTlListData();
          fetchTlData();
        }
      })
      .catch((error) => {
        const message =
          error?.response?.data?.message || "Something went wrong.";
        setSnackbarMessage(message);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  };

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(0, Math.min(newPage, pageCount - 1));
    setPage(newPageNumber);
  };

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, 5); // Show up to 5 page numbers
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(5 / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber)}
          className={page === pageNumber ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber + 1}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };

  return (
    <>
      <AppHeader />

      <div className="bg-[#f2f2f2] w-full pb-6">
        <div className="flex ">
          <DashboardFrontCard
            textFirstLine="Total TLs"
            clientData={tlCountData?.totalTl} // Show loader if loading
            imageURL="/assets/multiuser-blue.svg"
            lineImageURL="/assets/blue-line.svg"
          />
          <DashboardFrontCard
            textFirstLine="TLs Enabled"
            clientData={tlCountData?.enabledTl} // Show loader if loading
            imageURL="/assets/multiuser-green.svg"
            lineImageURL="/assets/green-line.svg"
          />
          <DashboardFrontCard
            textFirstLine="TLs Disabled"
            clientData={tlCountData?.disabledTl} // Show loader if loading
            imageURL="/assets/multiuser-red.svg"
            lineImageURL="/assets/red-line.svg"
          />
        </div>

        <div className="flex mx-6 mt-6">
          <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
            <div className="w-full">
              <Grid
                container
                spacing={5}
                className="w-full flex justify-between "
              >
                <Grid item md={4}>
                  <div className="flex ml-4">
                    <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                      ALL TL DETAILS
                    </h2>
                  </div>
                </Grid>
                <Grid item md={8}>
                  <div className="flex mr-4">
                    <div className="flex w-full justify-end">
                      <div className="mr-3">
                        <TextField
                          placeholder="Search by Mobile Number"
                          id="outlined-basic"
                          variant="outlined"
                          onChange={(search: any) => {
                            setSearchValInput(search.target.value);
                          }}
                          value={searchValInput}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment
                                position="end"
                                onClick={handleClearSearch}
                              >
                                <ClearIcon style={{ cursor: "pointer" }} />
                              </InputAdornment>
                            ),
                            style: { height: "40px", borderRadius: "25px" },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>

              <TableContainer>
                {!tlListData ? ( // Check if API response is still undefined (loading)
                  <LinearProgress />
                ) : typeof tlListData === "string" ? ( // If API returns "No Data Found" as a string
                  <Typography style={{ textAlign: "center", padding: "10px" }}>
                    No data available
                  </Typography>
                ) : tlListData.length === 0 ? ( // If the array is empty
                  <Typography style={{ textAlign: "center", padding: "10px" }}>
                    No data available
                  </Typography>
                ) : (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                          }}
                          sx={{ minWidth: 100 }}
                        >
                          TL Id
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                          }}
                          sx={{ minWidth: 100 }}
                        >
                          TL Name
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                          }}
                          sx={{ minWidth: 100 }}
                        >
                          Mobile
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                          }}
                          sx={{ minWidth: 100 }}
                        >
                          Hub Location
                        </TableCell>
                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                          }}
                          sx={{ minWidth: 150 }}
                        >
                          Total Rider Count
                        </TableCell>

                        <TableCell
                          style={{
                            ...tableHeaderCellStyle,
                            textAlign: "center",
                          }}
                          sx={{ minWidth: 100 }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tlListData?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell
                            style={{
                              ...tableBodyCellStyle,
                              textAlign: "center",
                            }}
                          >
                            {item.tlId}
                          </TableCell>

                          <TableCell
                            style={{
                              ...tableBodyCellStyle,
                              textAlign: "center",
                            }}
                          >
                            {item.tlName}
                          </TableCell>
                          <TableCell
                            style={{
                              ...tableBodyCellStyle,
                              textAlign: "center",
                            }}
                          >
                            {item.mobile}
                          </TableCell>
                          <TableCell
                            style={{
                              ...tableBodyCellStyle,
                              textAlign: "center",
                            }}
                          >
                            {item.hubLocation}
                          </TableCell>

                          <TableCell
                            style={{
                              ...tableBodyCellStyle,
                              textAlign: "center",
                            }}
                          >
                            {item.totalRiderCount}
                          </TableCell>
                          <TableCell
                            style={{
                              ...tableBodyCellStyle,
                              textAlign: "center",
                            }}
                          >
                            <span
                              onClick={() => {
                                setSelectedTlId(item.tlId);
                                setOpenRejectModal(true);
                                setListData(item);
                              }}
                              style={{
                                backgroundColor: "red",
                                color: "#fff",
                                paddingInline: "18px",
                                paddingBlock: "4px",
                                borderRadius: "14px",
                                width: "100px",
                                font: "Rubik",
                                fontSize: "14px",
                                cursor: "pointer",
                              }}
                            >
                              Disable
                            </span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </TableContainer>

              <div className="pl-2 pt-4 pb-2 pr-16">
                <div
                  className="pagination"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <button
                      onClick={() => handlePageChange(page - 1)}
                      disabled={page === 0}
                      style={{
                        fontFamily: "Rubik",
                        fontSize: "20px",
                        marginRight: "6px",
                      }}
                    >
                      {"<"}
                    </button>
                    {renderPageNumbers()}
                    <button
                      onClick={() => handlePageChange(page + 1)}
                      disabled={page >= pageCount - 1}
                      style={{
                        fontFamily: "Rubik",
                        fontSize: "20px",
                        marginLeft: "6px",
                      }}
                    >
                      {">"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Dialog
          open={openRejectModal}
          onClose={() => setOpenRejectModal(false)}
        >
          <DialogTitle
            style={{
              backgroundColor: "green",
              color: "#fff",
              padding: "5px 10px",
            }}
          >
            Are you sure to Disable TL?
          </DialogTitle>
          <hr />
          <DialogContent>
            <Box display="flex" flexDirection="column" gap={1}>
              <Typography variant="subtitle1">
               <b> TL Name: </b> {listData?.tlName || "N/A"}
              </Typography>
              <Typography variant="subtitle1">
                <b>Mobile: </b>{listData?.mobile || "N/A"}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions style={{ marginTop: "15px", textAlign: "left" }}>
            <Button
              variant="contained"
              color="error"
              onClick={() => setOpenRejectModal(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                if (selectedTlId) {
                  handleDisableClick(selectedTlId);
                  setOpenRejectModal(false);
                }
              }}
              variant="contained"
              color="success"
            >
              Disable TL
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={successModalOpen}>
          <DialogTitle
            style={{
              backgroundColor: "green",
              color: "#fff",
              padding: "5px 10px",
            }}
          >
            Success
          </DialogTitle>
          <DialogContent style={{ marginTop: "15px", textAlign: "left" }}>
            TL disabled successfully!
          </DialogContent>
        </Dialog>
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert
            severity={snackbarSeverity}
            onClose={() => setSnackbarOpen(false)}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default Dashboard;
